 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard-page":"dashboard-page","attendance-settings":"attendance-settings","attendance-staff":"attendance-staff","attendance-student":"attendance-student","leave-view":"leave-view","promotion-page":"promotion-page","leave-index":"leave-index","leave-manage":"leave-manage"}[chunkId]||chunkId) + "." + {"chunk-163262b0":"f9fcdd37","chunk-16cc7dff":"12025efd","chunk-2ba35a75":"041b703c","chunk-2d0b2758":"bb87bf22","chunk-2d0bd262":"7135fd5c","chunk-2d2375de":"fb8d68f7","chunk-2d3dfabb":"55560a52","dashboard-page":"3f21e2e4","chunk-55ed8718":"e97a502f","chunk-1a58f2ee":"e49021ae","chunk-07293bbe":"54dadafd","chunk-0fc3a472":"c42aa005","chunk-19721dde":"ce335691","chunk-2cb31b98":"fc67ed35","chunk-4ae8b4a5":"b46f82f0","attendance-settings":"d0dd9ce7","attendance-staff":"eecb8aa1","attendance-student":"d0b19c61","chunk-059c4a32":"e973559f","chunk-1c9eb05b":"f19e36dd","chunk-2267296e":"e17145ef","chunk-27bae1d7":"ee50bed5","chunk-27c31ce0":"e48f4fea","chunk-39ca04fa":"7c74d5f0","chunk-3cf7910c":"246650fd","chunk-3e83ae86":"70523ae9","chunk-40e4b917":"e2b08e36","chunk-44ac0887":"fe6e382f","chunk-501817ae":"5cb5ee24","chunk-61403b95":"82bd5aee","chunk-676bdbd4":"0d0a6425","chunk-71993736":"163b19d3","chunk-9ffee648":"8c3fdd4e","chunk-bc271444":"6b1e0473","chunk-ce944320":"20f6463b","leave-view":"471ab790","chunk-32995fac":"9f61b680","chunk-4f094858":"73dc5aa6","chunk-5c16d959":"3900700c","chunk-5d39fdf8":"f0e52cbf","promotion-page":"868d10ff","chunk-6b7345d8":"6dccdee7","chunk-6ca036e8":"a3830ef3","chunk-32b0a7ff":"00715ca9","chunk-7a447230":"fd5fcddf","chunk-7c68c914":"cb0c15b6","chunk-c4c0a43c":"ad6a331f","chunk-ec6522ba":"67df4f82","chunk-685c54f6":"b2182929","chunk-7e315f6b":"7fa12519","chunk-1fd7b65c":"8ba2ae67","chunk-22e7ae8a":"286a623f","chunk-0e389f44":"5f4613fd","chunk-1eccfd2e":"fd96f98d","chunk-2d213a9d":"0adb3c29","chunk-1457724b":"0d103abf","chunk-3db33590":"179b9664","chunk-428d31cc":"60a1b071","chunk-45c2728c":"2a45bc11","chunk-59275d91":"5354b257","chunk-03154a3d":"9cd867d8","chunk-724ab6b8":"c03c52f5","chunk-f5975746":"13a61a7f","chunk-09587897":"e1f675d6","leave-index":"a795b75d","leave-manage":"bf86da1a","chunk-364c4f92":"c0ac546a","chunk-a3840ca4":"94afbf12","chunk-8889c564":"c332ccbe","chunk-4671f692":"9c8fb63f","chunk-6352288a":"1f48a55d","chunk-2b6aa598":"4a8185f7","chunk-46dfc88a":"f725abc3","chunk-88294324":"7d609a0f","chunk-c613e504":"efa95992","chunk-220192a3":"66e4df7a","chunk-f82ba024":"8635ce00","chunk-1cc338da":"a30f3edb","chunk-2d0d3c78":"8a2039f6","chunk-7164948e":"b06481d4","chunk-5a839a91":"57c1eef1","chunk-6adf507b":"b1d85c2a","chunk-83b877b0":"830ff097","chunk-2a0aa8e1":"ffa1b1cf","chunk-095b8e6a":"b6feeb15","chunk-5994fe97":"a50e355f","chunk-4527f389":"63cf2f51","chunk-3dca3bc8":"dc914869","chunk-568c2bb4":"e43c634e","chunk-c689beb2":"4afddfe0","chunk-7c204d6e":"d9bbed7f","chunk-f31e7a4a":"a294e9b2","chunk-32c4fd62":"75704364","chunk-244b7391":"ef5ffe5e","chunk-cd4b845a":"b66ed6ea","chunk-2d0daf14":"e4bd77ac","chunk-7901d1c0":"7673bca0","chunk-bdc84446":"77c44744","chunk-73d5f09c":"c8c08374","chunk-f98f6134":"7ab09f4c","chunk-de73ad10":"667ed307","chunk-4ce72898":"d6ba1694","chunk-2d0bac58":"8177ea37","chunk-7aa99c5e":"e862abf4","chunk-c8512ebe":"7c35089a","chunk-276c4517":"b317697e","chunk-327384a4":"1d4e81d0","chunk-3c97ae80":"e9941b0c","chunk-9e406e7e":"c89c2722","chunk-496f936b":"d654105a","chunk-710e50e3":"39672b13","chunk-2ea01c06":"a6d0da30","chunk-dd907298":"26f31a9e","chunk-6c4e40a8":"45ffa1ae","chunk-1f60cbe8":"a1b763a7","chunk-a66df572":"1bd89eea","chunk-6a7cf333":"27aa789a","chunk-26724056":"c30777d2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-163262b0":1,"chunk-16cc7dff":1,"chunk-2ba35a75":1,"chunk-2d3dfabb":1,"dashboard-page":1,"chunk-55ed8718":1,"chunk-1a58f2ee":1,"chunk-07293bbe":1,"chunk-0fc3a472":1,"chunk-19721dde":1,"chunk-2cb31b98":1,"chunk-4ae8b4a5":1,"attendance-settings":1,"attendance-staff":1,"attendance-student":1,"chunk-059c4a32":1,"chunk-1c9eb05b":1,"chunk-2267296e":1,"chunk-27bae1d7":1,"chunk-27c31ce0":1,"chunk-39ca04fa":1,"chunk-3cf7910c":1,"chunk-3e83ae86":1,"chunk-40e4b917":1,"chunk-44ac0887":1,"chunk-501817ae":1,"chunk-61403b95":1,"chunk-676bdbd4":1,"chunk-71993736":1,"chunk-9ffee648":1,"chunk-bc271444":1,"chunk-ce944320":1,"leave-view":1,"chunk-32995fac":1,"chunk-4f094858":1,"chunk-5c16d959":1,"chunk-5d39fdf8":1,"promotion-page":1,"chunk-6b7345d8":1,"chunk-6ca036e8":1,"chunk-32b0a7ff":1,"chunk-7a447230":1,"chunk-7c68c914":1,"chunk-c4c0a43c":1,"chunk-ec6522ba":1,"chunk-685c54f6":1,"chunk-7e315f6b":1,"chunk-1fd7b65c":1,"chunk-22e7ae8a":1,"chunk-0e389f44":1,"chunk-1eccfd2e":1,"chunk-1457724b":1,"chunk-3db33590":1,"chunk-428d31cc":1,"chunk-45c2728c":1,"chunk-59275d91":1,"chunk-03154a3d":1,"chunk-724ab6b8":1,"chunk-f5975746":1,"chunk-09587897":1,"chunk-364c4f92":1,"chunk-a3840ca4":1,"chunk-8889c564":1,"chunk-4671f692":1,"chunk-6352288a":1,"chunk-2b6aa598":1,"chunk-46dfc88a":1,"chunk-88294324":1,"chunk-c613e504":1,"chunk-220192a3":1,"chunk-f82ba024":1,"chunk-1cc338da":1,"chunk-7164948e":1,"chunk-5a839a91":1,"chunk-6adf507b":1,"chunk-83b877b0":1,"chunk-2a0aa8e1":1,"chunk-095b8e6a":1,"chunk-5994fe97":1,"chunk-4527f389":1,"chunk-3dca3bc8":1,"chunk-568c2bb4":1,"chunk-c689beb2":1,"chunk-7c204d6e":1,"chunk-f31e7a4a":1,"chunk-32c4fd62":1,"chunk-244b7391":1,"chunk-cd4b845a":1,"chunk-7901d1c0":1,"chunk-bdc84446":1,"chunk-73d5f09c":1,"chunk-f98f6134":1,"chunk-de73ad10":1,"chunk-4ce72898":1,"chunk-7aa99c5e":1,"chunk-c8512ebe":1,"chunk-276c4517":1,"chunk-327384a4":1,"chunk-3c97ae80":1,"chunk-496f936b":1,"chunk-710e50e3":1,"chunk-2ea01c06":1,"chunk-dd907298":1,"chunk-6c4e40a8":1,"chunk-1f60cbe8":1,"chunk-a66df572":1,"chunk-6a7cf333":1,"chunk-26724056":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard-page":"dashboard-page","attendance-settings":"attendance-settings","attendance-staff":"attendance-staff","attendance-student":"attendance-student","leave-view":"leave-view","promotion-page":"promotion-page","leave-index":"leave-index","leave-manage":"leave-manage"}[chunkId]||chunkId) + "." + {"chunk-163262b0":"41e5bbbc","chunk-16cc7dff":"41e5bbbc","chunk-2ba35a75":"a3e07249","chunk-2d0b2758":"31d6cfe0","chunk-2d0bd262":"31d6cfe0","chunk-2d2375de":"31d6cfe0","chunk-2d3dfabb":"1fd09894","dashboard-page":"f6e2335d","chunk-55ed8718":"f9b0d815","chunk-1a58f2ee":"fd800a7a","chunk-07293bbe":"11bdcc95","chunk-0fc3a472":"a69389cc","chunk-19721dde":"9e75df13","chunk-2cb31b98":"9e85c2cb","chunk-4ae8b4a5":"c86a0600","attendance-settings":"c27e8fa3","attendance-staff":"097c9c04","attendance-student":"a79f1ca4","chunk-059c4a32":"be931bad","chunk-1c9eb05b":"4b8d62b0","chunk-2267296e":"d2c0e067","chunk-27bae1d7":"f1f41783","chunk-27c31ce0":"228e50d9","chunk-39ca04fa":"f11602ac","chunk-3cf7910c":"ea725027","chunk-3e83ae86":"36f32869","chunk-40e4b917":"d4ce358a","chunk-44ac0887":"ae13fe92","chunk-501817ae":"cdcc71ac","chunk-61403b95":"c7e4da14","chunk-676bdbd4":"68bdc1dd","chunk-71993736":"23c3dfa3","chunk-9ffee648":"b65dd0d7","chunk-bc271444":"f680e47a","chunk-ce944320":"947fe23c","leave-view":"5086b309","chunk-32995fac":"804bc566","chunk-4f094858":"f064063d","chunk-5c16d959":"fc969eb6","chunk-5d39fdf8":"a316c332","promotion-page":"bbc5acbb","chunk-6b7345d8":"2c71cf79","chunk-6ca036e8":"f2c924dc","chunk-32b0a7ff":"a946e694","chunk-7a447230":"993d4362","chunk-7c68c914":"1b2b781a","chunk-c4c0a43c":"804bc566","chunk-ec6522ba":"336faf06","chunk-685c54f6":"d656008e","chunk-7e315f6b":"89b3a868","chunk-1fd7b65c":"804bc566","chunk-22e7ae8a":"a733cb8d","chunk-0e389f44":"783eaaeb","chunk-1eccfd2e":"00d56ba8","chunk-2d213a9d":"31d6cfe0","chunk-1457724b":"652be334","chunk-3db33590":"d21ececa","chunk-428d31cc":"b4291d9f","chunk-45c2728c":"0363c97a","chunk-59275d91":"2ed53a5a","chunk-03154a3d":"8ad0bb85","chunk-724ab6b8":"248e7146","chunk-f5975746":"804bc566","chunk-09587897":"72bca70a","leave-index":"31d6cfe0","leave-manage":"31d6cfe0","chunk-364c4f92":"d7e2bfbf","chunk-a3840ca4":"f1a753e8","chunk-8889c564":"e1d22171","chunk-4671f692":"17546d6a","chunk-6352288a":"ce83abf8","chunk-2b6aa598":"fd190579","chunk-46dfc88a":"7b50670f","chunk-88294324":"dcc009ac","chunk-c613e504":"0e6997d4","chunk-220192a3":"ce83abf8","chunk-f82ba024":"d30ec597","chunk-1cc338da":"48db91e0","chunk-2d0d3c78":"31d6cfe0","chunk-7164948e":"53ead80b","chunk-5a839a91":"6de1dd0f","chunk-6adf507b":"416d869c","chunk-83b877b0":"62b71fde","chunk-2a0aa8e1":"a6cd620d","chunk-095b8e6a":"493dde95","chunk-5994fe97":"aa2bfe76","chunk-4527f389":"d4e4cc93","chunk-3dca3bc8":"ce83abf8","chunk-568c2bb4":"6d670df5","chunk-c689beb2":"3b5d52e4","chunk-7c204d6e":"de8709e7","chunk-f31e7a4a":"1fb7cb95","chunk-32c4fd62":"dcc009ac","chunk-244b7391":"1a7c3f70","chunk-cd4b845a":"a8b81c12","chunk-2d0daf14":"31d6cfe0","chunk-7901d1c0":"2ae4880f","chunk-bdc84446":"6749f998","chunk-73d5f09c":"3b5d52e4","chunk-f98f6134":"64b561e9","chunk-de73ad10":"64295909","chunk-4ce72898":"aee62b6b","chunk-2d0bac58":"31d6cfe0","chunk-7aa99c5e":"51df65c0","chunk-c8512ebe":"c035aa60","chunk-276c4517":"981edbf9","chunk-327384a4":"c6c8c3b3","chunk-3c97ae80":"97b9c847","chunk-9e406e7e":"31d6cfe0","chunk-496f936b":"40779ac0","chunk-710e50e3":"6ccce2fa","chunk-2ea01c06":"22b505e2","chunk-dd907298":"22b505e2","chunk-6c4e40a8":"6f9bf95f","chunk-1f60cbe8":"22e74c12","chunk-a66df572":"8ad0bb85","chunk-6a7cf333":"07a60e64","chunk-26724056":"ce83abf8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
